// 약관·처리방침 한 장 — 초안 안내 띠 · 제목 · 조항 목록.

import Banner from "@buildpy/ui/banner";
import { LEGAL_DRAFT_NOTICE, LEGAL_EFFECTIVE_DATE, type LegalDoc } from "@/modules/legal/content";

const LegalDocView = ({ doc, testId }: { doc: LegalDoc; testId: string }) => (
  <article className="flex max-w-3xl flex-col gap-6" data-testid={testId}>
    <Banner tone="warning">{LEGAL_DRAFT_NOTICE}</Banner>
    <div className="flex flex-col gap-2">
      <h1 className="text-3xl font-bold tracking-tight">{doc.title}</h1>
      <p className="text-sm text-muted-foreground">{LEGAL_EFFECTIVE_DATE}</p>
      <p className="leading-relaxed text-secondary-foreground">{doc.lead}</p>
    </div>
    {doc.articles.map((a) => (
      <section key={a.title} className="flex flex-col gap-2">
        <h2 className="text-lg font-semibold">{a.title}</h2>
        {a.body.map((line) => (
          <p key={line} className="leading-relaxed text-secondary-foreground">
            {line}
          </p>
        ))}
      </section>
    ))}
  </article>
);

export default LegalDocView;
